var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20711 9.20711C9.59763 8.81658 9.59763 8.18342 9.20711 7.79289C8.81658 7.40237 8.18342 7.40237 7.79289 7.79289L5.29289 10.2929C4.90237 10.6834 4.90237 11.3166 5.29289 11.7071L7.79289 14.2071C8.18342 14.5976 8.81658 14.5976 9.20711 14.2071C9.59763 13.8166 9.59763 13.1834 9.20711 12.7929L7.41421 11L9.20711 9.20711Z",
    fill: "#9FB3C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 22C1.567 22 0 20.433 0 18.5V3.5C0 1.567 1.567 0 3.5 0H18.5C20.433 0 22 1.567 22 3.5V18.5C22 20.433 20.433 22 18.5 22H3.5ZM2 3.5C2 2.67157 2.67157 2 3.5 2H13.75V20H3.5C2.67157 20 2 19.3284 2 18.5V3.5ZM15.75 20V2H18.5C19.3284 2 20 2.67157 20 3.5V18.5C20 19.3284 19.3284 20 18.5 20H15.75Z",
    fill: "#9FB3C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon);
export default __webpack_public_path__ + "static/media/sidebar-icon.d644fcbf437f641c22ea8426cc59c723.svg";
export { ForwardRef as ReactComponent };